import { combineReducers } from "redux"

import config from "./config"
import menu from "./menu"
import youtube from "./yotube"
import login from "./login"
import board from "./board"
import user from "./user"

export default combineReducers({
  config,
  menu,
  youtube,
  login,
  board,
  user,
})
